module.exports = __webpack_public_path__ + "static/media/Expanding-Horizons-blog-img.4e6552e9.webp";